/**
 * 导航菜单翻译 - 中文
 * Navigation translations - Chinese
 */

export default {
  home: '首页',
  coreService: '核心服务',
  industrySolutions: '行业解决方案',
  caseStudies: '案例展示',
  resourceCenter: '资源中心',
  customerSupport: '客户支持',
  about: '关于我们',
  contact: '联系我们',
  search_placeholder: '有技术问题？我们的AI引擎可以帮助您。'
}

